import type { CSSProperties } from 'react';
import { designTokens } from '@course-authoring/shared-types';

export const lessonEditorPageStyles: Record<string, CSSProperties> = {
  editorContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 16px',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: designTokens.colors.textMuted,
    backgroundColor: designTokens.colors.inspectorBackground,
    transition: 'background-color 0.2s ease',
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    border: 'none',
    background: 'none',
    color: designTokens.colors.textMuted,
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
  },
  courseNameInput: {
    fontSize: '16px',
    fontWeight: 600,
    color: designTokens.colors.textPrimary,
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '2px solid transparent',
    padding: '4px 8px',
    flex: '1 1 200px',
    minWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    outline: 'none',
    transition: 'all 0.2s',
  },
  lessonIdBadge: {
    fontSize: '13px',
    color: designTokens.colors.textSecondary,
    whiteSpace: 'nowrap',
  },
  saveStatus: {
    fontSize: '13px',
    color: designTokens.colors.textSecondary,
    minWidth: '80px',
    textAlign: 'right',
  },
  publishBannerContainer: {
    padding: '12px 16px 0',
    borderBottom: `1px solid ${designTokens.colors.textMuted}`,
  },
  exportButton: {
    padding: '6px 12px',
    fontSize: '13px',
    fontWeight: 500,
    color: designTokens.colors.textPrimary,
    backgroundColor: 'transparent',
    border: `1px solid ${designTokens.colors.textMuted}`,
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    transition: 'all 0.15s ease',
  },
  modeToggle: {
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    borderRadius: '8px',
    padding: '3px',
    marginRight: '12px',
  },
  modeButton: {
    padding: '6px 14px',
    fontSize: '13px',
    fontWeight: 500,
    color: designTokens.colors.textSecondary,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  modeButtonLeft: {
    borderRadius: '6px 0 0 6px',
  },
  modeButtonMiddle: {
    borderRadius: 0,
  },
  modeButtonRight: {
    borderRadius: '0 6px 6px 0',
  },
  modeButtonActive: {
    backgroundColor: '#fff',
    color: designTokens.colors.textPrimary,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    borderRadius: '6px',
  },
  mainLayout: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    minHeight: 0,
  },
  previewLayout: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  loading: {
    padding: '48px',
    textAlign: 'center',
    color: designTokens.colors.textSecondary,
  },
  error: {
    padding: '48px',
    textAlign: 'center',
    color: designTokens.colors.errorText,
  },
  saveErrorAlert: {
    padding: '10px 16px',
    color: designTokens.colors.errorText,
    backgroundColor: designTokens.colors.errorBackground,
  },
};
